<template>
  <div class="jobs-create" v-loading="loading" style="padding-top: 20px">
    <el-form>
      <div style="width: 100%">
        <span class="obj-name" v-if="object">
          Выбранный объект: <strong>{{ ` ` + object.name }}</strong>
        </span>
        <AddObjects
          v-if="!obj"
          :confirmDisable="true"
          :isSelect="!!object"
          @add-objects="(n) => object = n"
        />
      </div>
      <el-form-item label="Наименование материала">
        <el-input v-model="form.name" placeholder="Наименование материала"/>
      </el-form-item>
      <unit-select  v-model="form.unit"/>
      <el-form-item label="Документ о качестве">
        <el-input v-model="form.quality" placeholder="Документ о качестве"/>
      </el-form-item>
      <el-form-item label="Примечание">
        <el-input v-model="form.note" placeholder="Примечание"/>
      </el-form-item>
      <el-checkbox v-model="form.is_unit_value">Мерный материал</el-checkbox>
      <el-form-item
        v-if="form.is_unit_value"
        label="Объем на 1 ед.">
        <el-input  @change="plan" v-model="form.unit_value" placeholder="Объем на 1 ед."/>
      </el-form-item>
      <el-form-item
        v-if="form.is_unit_value"
        label="Количество">
        <el-input @change="plan" v-model="form.value" placeholder="Количество"/>
      </el-form-item>
      <el-form-item label="Плановый объем">
        <el-input v-model="form.plan" placeholder="Плановый объем"/>
      </el-form-item>
      <div class="jobs-create__buttons">
        <el-button v-if="$route.name !== 'MaterialsEdit'" @click="close">Отмена</el-button>
        <el-button v-else type="danger" @click="deleteObject">Удалить</el-button>

        <el-button v-if="$route.name !== 'MaterialsEdit'" type="primary" @click="save">Сохранить</el-button>
        <el-button v-else type="primary" @click="edit">Редактировать</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import firebase from 'firebase';
import FilterSelect from '../../../components/FilterSelect';
import AddObjects from '../Reports/components/AddObjects';
import { BigNumber } from "bignumber.js";
import {getUnits} from '../../../firestore/units';
import UnitSelect from '../components/unitSelect';

export default {
  name: 'MaterialsCreate',
  props: {
    isNested: Boolean,
    obj: String,
  },
  components: {UnitSelect, AddObjects, FilterSelect},
  data() {
    return {
      loading: false,
      checked: false,
      object: null,
      form: {
        name: '',
        quality: '',
        plan: '',
        type: 'MATERIALS',
        note: '',
        unit: '',
        unit_value: null,
        is_unit_value: false,
        value: '',
        work_type: null,
        kind: null,
      },
      options_works: [],
      options: [
        {
          value: 'JOB',
          label: 'Работы',
        },
        {
          value: 'TECH',
          label: 'Техника',
        },
        {
          value: 'PROF',
          label: 'Профессия',
        },
      ],
    };
  },

  async mounted() {

    this.options_units = {
      ...this.options_units,
      main: await getUnits(this.$store.state.project.id),
    };

    let req = null;
    const result = [];
    const where_param = this.$route.params.type ? this.$route.params.type.toLowerCase() : 'job';

    req = myFirestore
      .collection('projects')
      .doc(this.$store.state.project.id)
      .collection('works_type')
      .where('type', 'in', [where_param, where_param.toUpperCase()]);

    if (this.$route.query.obj) {
      this.getObject(this.$route.query.obj);
    }

    req.get()
      .then((data) => {
        data.forEach((subDoc) => {
          const data = subDoc.data();
          result.push({
            id: subDoc.id,
            name: data.name,
          });
        });
      })
      .finally(() => {
        this.options_works = result;
        this.loader = false;
      });

    if (this.$route.name === 'MaterialsEdit') {
      myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('jobs').doc(this.$route.params.id).get().then((data) => {

        const subData = data.data();
        const unit = this.options_units.main.find((f) => f.label === subData.unit);

        if (subData.objects[0]) {
          this.getObject(subData.objects[0]);
        }

        let work_type = subData.work_type;

        if (!this.options_works.find((e) => e.id === subData.work_type)) {
          work_type = null;
        }


        this.form = {
          ...subData,
          work_type,
          unit,
        };
      });
    } else {
      if (this.$route.params.id) {
        this.getObject(this.$route.params.id);
      }
    }

  },

  methods: {
    plan() {
      const plan = new BigNumber(this.form.value.replace(',', '.'))
        .multipliedBy(this.form.unit_value.replace(',', '.')).toNumber();
      this.form.plan = plan || 0;
    },
    getObject(id) {
      const result = [];
      myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('objects')
        .doc(id)
        .get()
        .then((subDoc) => {
          const data = subDoc.data();
          if(data) {
            result.push({
              id: subDoc.id,
              name: data.name || '',
              objects: data.objects,
              parentId: data.parentId || undefined,
              isParent: data.isParent,
            });
          }
        }).finally(() => {
        // const obj = getChildList(result);
        if (result && result[0]) {
          this.object = result[0];
        }
      });
    },
    deleteObject() {
      this.$confirm('Вы действительно хотите удалить?', 'Подтверждение', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {
        myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('jobs')
          .doc(this.$route.params.id).delete()
          .then((data) => {
            this.$emit('update');
            this.fetchJobs();
            this.$notify({
              offset: 60,
              title: 'Успешно!',
              message: 'удалено',
              type: 'success',
            });
          });
      });
    },
    close() {
      if (!this.isNested) {
        this.$router.go(-1);
      }
      this.$emit('close');
    },

    edit() {
      let work_type = null;
      if (this.form.work_type) {
        work_type = this.options_works.find((opt) => opt.id === this.form.work_type);
      }
      const objectID = (this.object && this.object.id);
      this.loading = true;
      myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('jobs').doc(this.$route.params.id)
        .update({
          name: this.form.name,
          plan: this.form.plan,
          quality: this.form.quality,
          note: this.form.note,
          type: this.form.type,
          kind: this.form.kind,
          unit_value: this.form.unit_value,
          is_unit_value: this.form.is_unit_value,
          objects: [objectID || 'all'],
          unit: this.form.unit && this.form.unit.label || null,
          work_type: (this.form.work_type && this.form.work_type.value) || '',
          work_type_name: work_type && work_type.label || '',
        }).then((add) => {
        this.$notify({
          offset: 60,
          title: 'Успешно!',
          message: 'Работа отредактирована',
          type: 'success',
        });
        setTimeout(() => this.$router.go(-1), 1000);
      }).catch((error) => {
        console.error(error);
        this.$notify({
          offset: 60,
          title: 'Упс... ',
          message: 'Произошла ошибка повторите позже',
          type: 'error',
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    save() {
      this.loading = true;
      const objectID = (this.object && this.object.id);

      let objects = this.$route.params.id === 'new' || this.checked ? [objectID || 'all'] : [objectID || this.obj || this.$route.params.id || 'all'];

      if (this.$route.params.type === 'TECH' || this.$route.params.type === 'PROF') {
        objects = ['all'];
      }
      const work_type = this.options_works.find((opt) => opt.id === this.form.work_type);

      const form = {...this.form};
      delete form.job;

      myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('jobs')
        .add({
          ...form,
          work_type_name: work_type && work_type.label || '',
          work_type: (this.form.work_type && this.form.work_type.value) || '',
          unit: this.form.unit.label || null,
          objects,
        }).then((add) => {
        this.$notify({
          offset: 60,
          title: 'Успешно!',
          message: 'Новыая работа добавлена',
          type: 'success',
        });
        this.form = {
          name: '',
          plan: '',
          type: '',
          unit: '',
        };
        setTimeout(() => {
          if (!this.isNested) {
            this.$router.go(-1);
          }
          this.$emit('created');
        }, 1000);
      }).catch((error) => {
        console.error(error);
        this.$notify({
          offset: 60,
          title: 'Упс... ',
          message: 'Произошла ошибка повторите позже',
          type: 'error',
        });
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.jobs-create {
  max-width: 382px;
  width: calc(100% - 40px);
  margin: 42px auto;

  > > > .el-form-item {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    .el-form-item__content {
      display: flex;
      justify-content: flex-start;
      width: 100%;
    }

    .el-form-item__label {
      padding: 0;
    }
  }

  &__buttons {
    margin-top: 28px;
    justify-content: space-between;
    width: 100%;
    flex: 1;
    display: flex;

    &:before {
    }

    &:after {
    }
  }

  .input-line-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
    flex: 1;
  }

  .select-type {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }
}

.obj-name {
  text-align: left;
  margin-bottom: 10px;
  display: flex;
  width: 100%;
  justify-content: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Jobs/Materials.vue